import React, { useState, useEffect } from 'react';
import { X } from 'lucide-react';
import AdBanner from './AdBanner';

const StickyAd: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isDismissed, setIsDismissed] = useState(false);

  useEffect(() => {
    // Show sticky ad after scrolling 500px
    const handleScroll = () => {
      if (window.scrollY > 500) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  if (isDismissed) return null;

  return (
    <div 
      className={`fixed bottom-0 left-0 right-0 bg-white shadow-lg border-t border-neutral-200 p-2 sm:hidden transform transition-transform ${
        isVisible ? 'translate-y-0' : 'translate-y-full'
      } z-40`}
    >
      <button 
        onClick={() => setIsDismissed(true)}
        className="absolute top-1 right-1 p-1 bg-white/80 rounded-full z-10"
        aria-label="Close advertisement"
      >
        <X size={16} className="text-neutral-500" />
      </button>
      <AdBanner 
        id="sticky-mobile"
        slot="footer"
        size="mobile"
      />
    </div>
  );
};

export default StickyAd;